import { render } from "./huaweiLogin.vue?vue&type=template&id=6f6af960&scoped=true"
import script from "./huaweiLogin.vue?vue&type=script&lang=js"
export * from "./huaweiLogin.vue?vue&type=script&lang=js"

import "./huaweiLogin.vue?vue&type=style&index=0&id=6f6af960&lang=scss&scoped=true"

import exportComponent from "/data/soft/jenkins/workspace/S09_ehm-acsecurity-pro-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6af960"]])

export default __exports__